module.exports = __webpack_public_path__ + "static/img/partnerList.f0462034.png";